import Component from '../../lib/component'
import { RootComponent } from '../../main'
import { isTabbable } from 'tabbable'

export default class HashAnchorComponent extends Component {
    static selector () {
        return `a[href^="#"], a[href^="${window.location.href
            .replace(window.location.hash, '')
            .replace(`?${window.location.search}`)}#"]`
    }

    constructor (opts) {
        super(opts)

        if (this.el.getAttribute('href') === '#')
            return this.el.setAttribute('data-rendered', false)

        this.listen()

        if (window.location.hash !== this.el.hash)
            return

        this.onHashChange()
        this.el.click()
    }

    listen () {
        this.el.addEventListener('click',
            this.onHashAnchorClick.bind(this))

        this.el.addEventListener('keydown',
            this.onHashAnchorKeydown.bind(this))

        window.addEventListener('hashchange',
            this.onHashChange.bind(this))
    }

    onHashChange (e) {
        if (window.location.hash !== this.el.hash
                || !('history' in window))
            return

        window.history.replaceState(null, null,
            window.location.href.replace(window.location.hash, ''))
    }

    onHashAnchorKeydown (e) {
        if (e.keyCode === 32
                || (e.keyIdentifier || e.key || '').match(/^(enter)$/i))
            return this.onHashAnchorClick(e)
    }

    onHashAnchorClick (e) {
        e.preventDefault()
        e.stopPropagation()

        const targetId = this.el.getAttribute('href')
            .replace(/(.+)(#.+)/, '$2')

        const target = targetId
            ? document.querySelector(targetId)
            : null

        if (!target
                || !RootComponent.Scroller
                || RootComponent.Scroller.scrollingTo)
            return

        this.el.blur()

        const top = target.getBoundingClientRect().top
            + (RootComponent.Scroller.state.get('scrollY') || 0)
            - this.getScrollOffsetY()

        Promise
            .resolve(this.getBrowser('name') === 'ios'
                ? window.scrollTo(0, top)
                : RootComponent.Scroller.scrollTo({ y: top }))
            .then(() => {
                const isTargetTabbable = isTabbable(target)

                if (!isTargetTabbable
                        && !target.getAttribute('tabindex')) {
                    target.setAttribute('data-tabindex-reset', true)
                    target.setAttribute('tabindex', -1)
                }

                target.focus()

                if (target.getAttribute('data-tabindex-reset') !== 'true')
                    return

                setTimeout(() => {
                    target.removeAttribute('data-tabindex-reset')
                    target.removeAttribute('tabindex')
                }, 1)
            })
    }

    getScrollOffsetY () {
        return Number((this.props.scrollOffsetY || 0))
            + Number(((RootComponent || {}).props || {}).scrollOffset || 0)
    }
}
